import React, { useState, createContext } from 'react';
import Theme from './Theme';

const DataContext = createContext();

function DataProvider({children}) {
    const [settings, setSettings] = useState({
      background_audio: false,
      background_volume: 0.1,
      audio_volume: 0.5,
      active_theme: '' // save to localstorage 
    });

    const [themes, setThemes] = useState([
      new Theme('default', 'Default'),
      new Theme('shiny', 'Shiny'),
      new Theme('ahri', 'Ahri'),
    ]);
  
    return (
      <DataContext.Provider value={{settings, setSettings, themes, setThemes}}>
        {children}
      </DataContext.Provider>
    )
}
export { DataProvider, DataContext };
